import { useState } from 'react';
import Modal, { ModalHeader, ModalFooter } from 'components/common/Modal';
import Button from 'components/common/Button';
import { Subtitle } from 'components/styled/Typography';
import { CopyIcon, CheckIcon } from 'components/common/Icons';
import { copyToClipboard } from 'utils/copyToClipboard';

const EmailRow = ({ label, email }) => {
  const [copied, setCopied] = useState(null);
  const copy = () => {
    copyToClipboard(email);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };
  return (
    <div className="flex items-center gap-1">
      <span className="text-sm">{label}</span>
      <code className="text-sm select-all">{email}</code>

      <Button size="small" variant="text" onClick={copy} data-test-id={`copy-${email}-email`}>
        {copied ? <CheckIcon className="w-4 h-4" /> : <CopyIcon className="w-4 h-4" />}
      </Button>
    </div>
  );
};

const SystemInfoRow = () => {
  const [copied, setCopied] = useState(null);

  const systemInfo = `
Version: ${import.meta.env.VITE_RELEASE_VERSION || 'Unknown'}
Current Page: ${window.location.href}
`.trim();

  const copy = () => {
    copyToClipboard(systemInfo);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000);
  };

  return (
    <div className="pt-4 relative">
      <div className="text-xs font-semibold uppercase tracking-wide mb-2">Helpful info to include</div>
      <div className="absolute bottom-2.5 right-1.5">
        <Button size="small" variant="outlined" onClick={copy} data-test-id="copy-system-info">
          {copied ? <CheckIcon className="w-4 h-4" /> : <CopyIcon className="w-4 h-4" />}
        </Button>
      </div>
      <div
        className="w-full px-3 py-2 text-xs font-code border border-gray-300 rounded"
        data-test-id="system-info-textarea"
      >
        <pre className="overflow-hidden mr-8">{systemInfo}</pre>
      </div>
    </div>
  );
};

const OnPremiseSupportModal = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose} dataTestId="onprem-support-modal">
      <ModalHeader>
        <Subtitle>Support / Feature Requests</Subtitle>
      </ModalHeader>
      <div className="space-y-4">
        <EmailRow label="To submit a support request please email" email="support@mixmode.ai" />

        <EmailRow label="To submit a feature request please email" email="product@mixmode.ai" />

        <SystemInfoRow />
      </div>
      <ModalFooter>
        <Button variant="text" onClick={onClose} data-test-id="close-modal">
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OnPremiseSupportModal;
